// extracted by mini-css-extract-plugin
module.exports = {"content":"Content-content-980a"};